import CircularProgress from '@mui/material/CircularProgress';
export const Loader = () => (
  <CircularProgress
    size={50}
    thickness={2}
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
    }}
  />
);

export default Loader;
